import { render } from "./WhatsappSyncing.vue?vue&type=template&id=bc3ef622&scoped=true"
import script from "./WhatsappSyncing.vue?vue&type=script&lang=js"
export * from "./WhatsappSyncing.vue?vue&type=script&lang=js"

import "./WhatsappSyncing.vue?vue&type=style&index=0&id=bc3ef622&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc3ef622"]])

export default __exports__